'use client';
import cn from 'classnames';

import './cursor.css';

interface CursorProps {
  showCursor: boolean;
  isZoomed: boolean;
  mouseY: number;
  mouseX: number;
}

export default function Cursor({ showCursor, isZoomed, mouseY, mouseX }: Readonly<CursorProps>) {
  return (
    <div
      className={cn('cm-cursor', { 'cm-cursor--show': showCursor })}
      style={{
        top: `${mouseY}px`,
        left: `${mouseX}px`,
      }}
    >
      <div
        className={cn({
          'cm-cursor-zoom-out': isZoomed,
          'cm-cursor-zoom-in': !isZoomed,
        })}
      ></div>
    </div>
  );
}
